import { useNotificationsContext } from '@/contexts/NotificationsContext/NotificationsContext';

export const useDownloadDocument = () => {
  const {
    actions: { setSnackbarNotification },
  } = useNotificationsContext();

  const decodeBase64ImageAndDownload = (base64Data: string, fileName: string) => {
    const link = document.createElement('a');
    link.href = `data:image/png;base64,${base64Data}`;
    link.download = fileName;
    link.click();
  };

  function decodeBase64PDFAndDownload(base64Data: string, fileName: string) {
    const byteCharacters = atob(base64Data);
    const byteLength = byteCharacters.length;
    const byteArrays = new Array(byteLength);

    for (let i = 0; i < byteLength; i++) {
      byteArrays[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteArrays);

    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(link.href);
  }

  function decodeBase64MP4AndDownload(base64Data: string, fileName: string) {
    const byteCharacters = atob(base64Data);
    const byteLength = byteCharacters.length;
    const byteArrays = new Array(byteLength);

    for (let i = 0; i < byteLength; i++) {
      byteArrays[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteArrays);

    const blob = new Blob([byteArray], { type: 'video/mp4' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(link.href);
  }

  const getAndCallDownloadFunctionByMimeType = (mimeType: string, base64data: string, fileName: string) => {
    switch (mimeType) {
      case 'image/png':
      case 'image/jpg':
      case 'image/jpeg':
        return decodeBase64ImageAndDownload(base64data, fileName);
      case 'application/pdf':
        return decodeBase64PDFAndDownload(base64data, fileName);
      case 'video/mp4':
        return decodeBase64MP4AndDownload(base64data, fileName);
      default:
        return setSnackbarNotification({
          msg: 'THIS_MIME_FILE_TYPE_IS_NOT_POSSIBLE_TO_DOWNLOAD',
          level: 'warning',
        });
    }
  };

  return { getAndCallDownloadFunctionByMimeType };
};
